import React, { useEffect, useState } from "react";
import { ExlyInput } from "common/form";
import { useCustomizationStore } from "../../store/useCustomizationStore";
import { useWebpageSectionChange } from "../../store/useWebpageSectionChange";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";

export const InputSectionHandler = ({
  sectionKey,
  customFooter,
  placeholder,
  defaultValue = "",
  validate,
}) => {
  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue = sectionConfig[sectionKey]?.value;
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState(sectionValue || defaultValue);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setInputValue(sectionValue || defaultValue);
  }, [sectionValue, defaultValue]);

  const { handleSectionChange } = useWebpageSectionChange();

  const handleChange = (value) => {
    if (validate) {
      const validationError = validate(value);
      setError(validationError || "");
      if (validationError) return;
    }

    setInputValue(value);

    const payload = {
      feature_key: sectionKey,
      feature_value: value,
    };

    handleSectionChange({ payload });
  };

  return (
    <div className={!isDesktop ? "tw-w-100 !tw-mt-[-4px]" : "tw-w-[43%]"}>
      <ExlyInput
        value={inputValue}
        onChange={(value) => {
          setInputValue(value);
          if (error) setError("");
        }}
        onBlur={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        fullWidth
        inputClassName="tw-bg-white"
        error={!!error}
        helperText={error}
      />
      {customFooter && customFooter}
    </div>
  );
};
